export const systemErrorCodes: Record<string, string> = {
  EACCES: 'Permission denied',
  EADDRINUSE: 'Address already in use',
  ECONNREFUSED: 'Connection refused',
  ECONNRESET: 'Connection reset by peer',
  ENOTFOUND: 'DNS lookup failed',
  EPERM: 'Operation not permitted',
  EPIPE: 'Broken pipe',
  ETIMEDOUT: 'Operation timed out',
};
